import { API_ENDPOINT } from 'src/config/env.config';
import { baseApi } from './axios';
import {
	BaseAPIResponse,
	CreateMeetingLogInput,
	MentorFeedbackCreateInfo,
	GetOngoingAssessmentDetailsAPIResponse,
	ScheduleMeetingForRoundInput,
	GetParticipantToken,
	GetMeetingsAPIResponse,
	GetMeetingRecordingByIdAPIResponse,
	GetAllMeetingsAPIResponse,
	GetLatestUpdatedMeetingsAPIResponse,
	GetMeetingScoreCardAPIResponse,
	RescheduleMeetingInput,
	FilterQueryInput,
	GetSampleAssessmentByMeetingIdAPIResponse,
	GetAllMeetingsDetailAPIResponse,
	StartMeetingForRoundTemplate,
	GetPreferenceMeetingsAPIResponse,
	GetAllMockRoundTemplatesAPIResponse,
	StartMeetingForRoundTemplateResponse,
} from 'types';
import { GetMeetingByIdAPIResponse } from 'types';

const baseUrl = `${API_ENDPOINT}/meeting`;

export const getAllMockRoundTemplates = async ({
	hiringAssessmentId,
	token,
}: {
	hiringAssessmentId?: string;
	token?: string;
}): Promise<GetAllMockRoundTemplatesAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/getAllMockRoundTemplates`, {
		hiringAssessmentId,
		token: localStorage.getItem('guestUserJwtToken') || '',
	});
	return response.data;
};

export const getUserPreferenceMeetings = async ({
	hiringAssessmentId,
	token,
}: {
	hiringAssessmentId?: string;
	token?: string;
}): Promise<GetPreferenceMeetingsAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/getUserPreferenceMeetings`, {
		hiringAssessmentId,
		token,
	});
	return response.data;
};

export const startMeetingForRoundTemplate = async ({
	roundTemplateId,
	isMock,
	uniqueTestId,
	// following are for guest user

	hiringAssessmentId,
	token,
}: StartMeetingForRoundTemplate): Promise<StartMeetingForRoundTemplateResponse> => {
	const response = await baseApi.post(`${baseUrl}/startMeetingForRoundTemplate`, {
		roundTemplateId,
		isMock,
		uniqueTestId,
		// following are for guest user
		hiringAssessmentId,
		token,
	});
	return response.data;
};

// export const getMeetings = async (): Promise<GetMeetingsAPIResponse> => {
// 	const response = await baseApi.post(`${baseUrl}/all`);
// 	return response.data;
// };
export const getMeetings = async (): Promise<GetMeetingsAPIResponse> => {
	const token = localStorage.getItem('guestUserJwtToken');
	const response = await baseApi.post(`${baseUrl}/all`, null, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
	return response.data;
};

export const getMeetingById = async (id: string): Promise<GetMeetingByIdAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/getMeetingById/${id}`);
	return response.data;
};

export const getAllMeetings = async (filterData?: FilterQueryInput): Promise<GetAllMeetingsAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/all`, filterData);
	return response.data;
};

export const createMeetingLog = async (args: CreateMeetingLogInput): Promise<BaseAPIResponse> => {
	try {
		const response = await baseApi.post(`${baseUrl}/create-logs`, args);
		return response.data;
	} catch (err: any) {
		return { error: err, message: err.message };
	}
};

export const startMeeting = async (meetingId: string): Promise<BaseAPIResponse> => {
	try {
		const response = await baseApi.patch(`${baseUrl}/start-meeting/${meetingId}`);
		return response.data;
	} catch (err: any) {
		return { error: err, message: err.message };
	}
};

export const endMeeting = async (meetingId: string): Promise<BaseAPIResponse> => {
	try {
		const response = await baseApi.patch(`${baseUrl}/end-meeting/${meetingId}`);
		return response.data;
	} catch (err: any) {
		return { error: err, message: err.message };
	}
};

export const createParticipantToken = async (meetingId: string): Promise<GetParticipantToken> => {
	try {
		const response = await baseApi.post(`${baseUrl}/create-participant-token`, {
			meetingId,
		});
		return response.data;
	} catch (err: any) {
		return { error: err, message: err.message };
	}
};

export const getRecordingByMeetingId = async (meetingId: string): Promise<GetMeetingRecordingByIdAPIResponse> => {
	try {
		const token = localStorage.getItem('guestUserJwtToken');
		const response = await baseApi.get(`${baseUrl}/getRecordingsByMeetingId/${meetingId}`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data;
	} catch (err: any) {
		return { error: err, message: err.message };
	}
};

export const updateUnseenMeetingId = async (meetingId: string): Promise<BaseAPIResponse> => {
	try {
		const response = await baseApi.patch(`${baseUrl}/updateUnseenMeeting/${meetingId}`);
		return response.data;
	} catch (err: any) {
		return { error: err, message: err.message };
	}
};

export const addRatingByIdMentor = async (
	meetingId: string,
	data: MentorFeedbackCreateInfo,
): Promise<BaseAPIResponse> => {
	try {
		const response = await baseApi.patch(`${baseUrl}/addMentorRating/${meetingId}`, data);
		return response.data;
	} catch (err: any) {
		return { error: err, message: err.message };
	}
};

export const getLatestUpdatedMeetings = async (): Promise<GetLatestUpdatedMeetingsAPIResponse> => {
	try {
		const response = await baseApi.patch(`${baseUrl}/getLatestUpdatedMeetings`);
		return response.data;
	} catch (err: any) {
		return { error: err, message: err.message };
	}
};

export const scheduleMeeting = async (payload: ScheduleMeetingForRoundInput): Promise<BaseAPIResponse> => {
	if (payload.roundId) {
		const response = await baseApi.post(`${baseUrl}/schedule`, payload);
		return response.data;
	}
	const response = await baseApi.post(`${baseUrl}/template-schedule`, payload);
	return response.data;
};
export const rescheduleMeeting = async (payload: RescheduleMeetingInput): Promise<BaseAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/reschedule`, payload);
	return response.data;
};
export const getOngoingAssessmentDetails = async (
	meetingId: string,
): Promise<GetOngoingAssessmentDetailsAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/ongoing-assessment/${meetingId}`);
	return response.data;
};
// export const getMeetingScoreCard = async (meetingId: string): Promise<GetMeetingScoreCardAPIResponse> => {
// 	const response = await baseApi.get(`${baseUrl}/scorecard/${meetingId}`);
// 	return response.data;
// };
export const getMeetingScoreCard = async (meetingId: string): Promise<GetMeetingScoreCardAPIResponse> => {
	const token = localStorage.getItem('guestUserJwtToken');
	const response = await baseApi.get(`${baseUrl}/scorecard/${meetingId}`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
	return response.data;
};
export const cancelMeetingById = async (args: { id: string }): Promise<BaseAPIResponse> => {
	const response = await baseApi.patch(`${baseUrl}/cancel-meeting/${args.id}`);
	return response.data;
};

export const getSampleAssessmentByMeetingId = async (
	meetingId: string,
): Promise<GetSampleAssessmentByMeetingIdAPIResponse> => {
	try {
		const response = await baseApi.get(`${baseUrl}/sample-assessment/${meetingId}`);
		return response.data;
	} catch (err: any) {
		return { error: err, message: err.message };
	}
};

export const updateEndMeetingFlags = async (data: {
	meetingId: string;
	recommendReschedule: boolean;
	reasonForReschedule: string;
}): Promise<BaseAPIResponse> => {
	try {
		const response = await baseApi.patch(`${baseUrl}/update-meeting-flag/:${data.meetingId}`, {
			...data,
		});
		return response.data;
	} catch (err: any) {
		return { error: err, message: err.message };
	}
};

export const getAllMeetingsDetail = async (handler: string): Promise<GetAllMeetingsDetailAPIResponse> => {
	try {
		const response = await baseApi.get(`${baseUrl}/getAllMeetingsDetails/${handler}`);
		return response.data;
	} catch (error: any) {
		return { error: error, message: error.message };
	}
};
